import { PrivateInterceptor } from '../../../Base/interceptors/PrivateInterceptor'
import { toastShow } from '../../../Base/Services/ToastService';
import axios from 'axios'

export const getActivosFijosSimples = async () => {
  const response = await PrivateInterceptor('Global/ActivoFijo/ActivosSimples', 'GET');
  return response;
}

export const getActivosFijosById = async (IdActivo) => {
  const response = await PrivateInterceptor('Global/ActivoFijo/getActivosFijosById', 'POST', {IdActivo});
  return response;
}

// OBTENER ACTIVOS FIJOS
export const getActivosFijos = async (data) => {
  const response = await PrivateInterceptor('Global/ActivoFijo', 'POST', {data});
  return response;
}

// OBTENER ACTIVOS FIJOS TOTALES
export const getActivosFijosTotales = async (data) => {
  const response = await PrivateInterceptor('Global/ActivoFijo/Totales', 'POST', {data});
  return response;
}

// GUARDAR ACTIVOS FIJOS
export const GuardarActivosFijos = (Datos) => {
    const respuesta = PrivateInterceptor("Global/ActivoFijo/AgregarActivoFijo", "POST", {Datos});
    return respuesta;
};

// GUARDAR ACTIVOS FIJOS
export const EditarActivosFijos = (Datos) => {
  const respuesta = PrivateInterceptor("Global/ActivoFijo/EditarActivoFijo", "POST", {Datos});
  return respuesta;
};

export const getResumenActivos = async (data) =>{
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/resumenActivos`, 'POST', {data});
  return respuesta
}

export const getActivosTotales = async (data) =>{
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/getActivosTotales`, 'POST', {data});
  return respuesta
}

//OBTIENE DETALLE REQUISA POR REQUISA
export const obtenerActivosCodigo = async (CodigoActivo) => {
  const result = await PrivateInterceptor(`Global/ActivoFijo/CodigoAct`,"POST",{ CodigoActivo });
  return result;
};

export const getResumenDepreciacion = async (data) => {
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/ResumenDepreciacion`, 'POST', data);
  return respuesta
}

export const changeEstadoActivos = async (data) => {
  const result = await PrivateInterceptor(`Global/ActivoFijo/changeEstadoActivos`, 'POST', data);
  return result;
}

export const changeEstadoSubActivos = async (data) => {
  const result = await PrivateInterceptor(`Global/ActivoFijo/changeEstadoSubActivos`, 'POST', data);
  return result;
}

export const obtenerCodigoAct = async (IdTipoActivo, CodigoActivo) => {
  const result = await PrivateInterceptor(`Global/ActivoFijo/ObtenerCodigoActivo`,"POST",{ IdTipoActivo, CodigoActivo });
  return result;
};


// ----------------------------------------------------------------------- SUB ACTIVOS ------------------------------------------------------------------------

// OBTENER SUB ACTIVOS FIJOS
export const getSubActivosFijos = async (data) => {
  const response = await PrivateInterceptor('Global/SubActivoFijo', 'POST', {data});
  return response;
}

// OBTENER SUB ACTIVOS FIJOS
export const getSubActivosFijosPorID = async (IdActivo) => {
  const response = await PrivateInterceptor('Global/SubActivoFijo/PorID', 'POST', {IdActivo});
  return response;
}

// OBTENER CODIGO SUB ACTIVOS 
export const getCodSubAct = async () => {
  const response = await PrivateInterceptor('Global/SubActivoFijo/Codigo', 'GET');
  return response;
}

// GUARDAR SUB ACTIVOS FIJOS
export const GuardarSubActivosFijos = (Datos) => {
  const respuesta = PrivateInterceptor("Global/SubActivoFijo/AgregarSubActivoFijo", "POST", {Datos});
  return respuesta;
};

// GUARDAR ACTIVOS FIJOS
export const EditarSubActivosFijos = (Datos) => {
  const respuesta = PrivateInterceptor("Global/SubActivoFijo/EditarSubActivoFijo", "POST", {Datos});
  return respuesta;
};


// ----------------------------------------------------------------------- DISTRIBUCIONES ------------------------------------------------------------------------

export const putDistribuciones = async (data) => {
  const result = await PrivateInterceptor(`Global/ActivoFijo/Distribuciones/Save`, 'POST', data);
  return result;
}

export const getActivosByTipo = async (IdTipo) => {
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/getByType/${IdTipo}`, "GET");
  return respuesta
}

export const getDistribucionesTipo = async (IdTipo) => {
  const result = await PrivateInterceptor(`Global/ActivoFijo/Distribuciones/Tipo/${IdTipo}`, 'GET');
  return result;
}

export const getDistribucionesId= async (Id) => {
  const result = await PrivateInterceptor(`Global/ActivoFijo/Distribuciones/Id/${Id}`, 'GET');
  return result;
}

export const deleteDistribucionesEnc = async (Ids) => {
  const result = await PrivateInterceptor(`Global/ActivoFijo/Distribuciones/deleteEnc`, 'DELETE', {Ids});
  return result;
}

export const deleteDistribucionesDet = async (Ids) => {
  const result = await PrivateInterceptor(`Global/ActivoFijo/Distribuciones/deleteDet`, 'DELETE', {Ids});
  return result;
}

export const deleteDistribucionesDistr = async (Ids) => {
  const result = await PrivateInterceptor(`Global/ActivoFijo/Distribuciones/deleteDistr`, 'DELETE', {Ids});
  return result;
}
// ------------------------------------IMAGENES-----------------------------

const getFileExtension = (filename) => {
  const dotIndex = filename.lastIndexOf('.');
  if (dotIndex !== -1) {
    return filename.substring(dotIndex + 1).toLowerCase();
  }
  return ''; 
};


// ACTIVOS
export const ObtenerImagenes = async (CodigoActivo) => {
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/Imagenes/ObtenerImagenes/` + CodigoActivo, 'GET')
  return respuesta;
}

export const mostrarImagenes = async (CodigoActivo, nombre) => {
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/Imagenes/MostrarImagenes/${CodigoActivo}/${nombre}`, 'GET')
  var binary = '';
  var bytes = [].slice.call(new Uint8Array(respuesta.data));
  bytes.forEach((b) => binary += String.fromCharCode(b));
  const base64String = window.btoa(binary);
  return base64String;
}

export const SubirImagenes = ({ e, inputs, toast, ref, url, getArchivos = () => {}   }) => {
  const maxFileSize = 5 * 1024 * 1024; 
  const maxFiles = 5; 
  const acceptedFileExtensions = ['jpg', 'jpeg', 'png'];
  // console.log(e.files[0].name)
  const fileExtension = getFileExtension(e.files[0].name);

  if (!acceptedFileExtensions.includes(fileExtension.toLowerCase())) {
    toastShow(toast, 'error', 'Error','Solo se permiten subir Imágenes');
  }
  if (e.files.length > maxFiles) {
    if (toast) {
      toastShow(toast, 'error', 'Solo se permiten subir 5 imágenes.');
    }
    return; 
  }

  for (let i = 0; i < e.files.length; i++) {
    const file = e.files[i];

    if (file.size > maxFileSize) {
        if (toast) {
            toastShow(toast, 'error', `La Imagen excede el límite de tamaño (5MB)`);
        }
        continue;
    }

    var formData = new FormData();
    formData.append('file', file);

    inputs.forEach(input => {
      formData.append(input.name, input.value);
    });

    axios.post(`${process.env.REACT_APP_API_URL}/Global/ActivoFijo/Imagenes/SubirImagenes?${Date.now()}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-access-token': localStorage.getItem(process.env.REACT_APP_StorageToken),
      }
    }).then(res => {
      if (toast) {
        toastShow(toast, 'success', 'Agregada','Imágen agregada correctamente')
      }
      ref.current.clear();
      getArchivos()
    }).catch(err => {
      if (toast) {
        toastShow(toast, 'error', 'Error', 'Error al agregar imágen')
      }
    })
  }
}

export const descargarImagenes = async (CodigoActivo, nombre) => {
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/Imagenes/MostrarImagenes/${CodigoActivo}/${nombre}`, 'GET')
  return respuesta;
}

export const eliminarImagenes = async (CodigoActivo, nombre) => {
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/Imagenes/EliminarImagenes/${CodigoActivo}/${nombre}`, 'DELETE')
  return respuesta;
}

// SUB ACTIVOS
export const ObtenerImagenesSUB = async (CodigoSubActivo) => {
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/Imagenes/ObtenerImagenesSUB/` + CodigoSubActivo, 'GET')
  return respuesta;
}

export const mostrarImagenesSUB = async (CodigoSubActivo, nombre) => {
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/Imagenes/MostrarImagenesSUB/${CodigoSubActivo}/${nombre}`, 'GET')
  var binary = '';
  var bytes = [].slice.call(new Uint8Array(respuesta.data));
  bytes.forEach((b) => binary += String.fromCharCode(b));
  const base64String = window.btoa(binary);
  return base64String;
}

export const SubirImagenesSUB = ({ e, inputs, toast, ref, url, getArchivos = () => {}   }) => {
  const maxFileSize = 5 * 1024 * 1024; 
  const maxFiles = 5; 
  const acceptedFileExtensions = ['jpg', 'jpeg', 'png'];
  // console.log(e.files[0].name)
  const fileExtension = getFileExtension(e.files[0].name);

  if (!acceptedFileExtensions.includes(fileExtension.toLowerCase())) {
    toastShow(toast, 'error', 'Error','Solo se permiten subir Imágenes');
  }
  if (e.files.length > maxFiles) {
    if (toast) {
      toastShow(toast, 'error', 'Solo se permiten subir 5 imágenes.');
    }
    return; 
  }

  for (let i = 0; i < e.files.length; i++) {
    const file = e.files[i];

    if (file.size > maxFileSize) {
        if (toast) {
            toastShow(toast, 'error', `La Imagen excede el límite de tamaño (5MB)`);
        }
        continue;
    }

    var formData = new FormData();
    formData.append('file', file);

    inputs.forEach(input => {
      formData.append(input.name, input.value);
    });

    axios.post(`${process.env.REACT_APP_API_URL}/Global/ActivoFijo/Imagenes/SubirImagenesSUB?${Date.now()}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        'x-access-token': localStorage.getItem(process.env.REACT_APP_StorageToken),
      }
    }).then(res => {
      if (toast) {
        toastShow(toast, 'success', 'Agregada','Imágen agregada correctamente')
      }
      ref.current.clear();
      getArchivos()
    }).catch(err => {
      if (toast) {
        toastShow(toast, 'error', 'Error', 'Error al agregar imágen')
      }
    })
  }
}

export const descargarImagenesSUB = async (CodigoSubActivo, nombre) => {
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/Imagenes/MostrarImagenesSUB/${CodigoSubActivo}/${nombre}`, 'GET')
  return respuesta;
}

export const eliminarImagenesSUB = async (CodigoSubActivo, nombre) => {
  const respuesta = await PrivateInterceptor(`Global/ActivoFijo/Imagenes/EliminarImagenesSUB/${CodigoSubActivo}/${nombre}`, 'DELETE')
  return respuesta;
}


//HISTORICO TRANSFERENCIAS
// OBTENER ACTIVOS FIJOS
export const getHistoricos = async (data) => {
  const response = await PrivateInterceptor('Global/ActivoFijo/HistoricoTranferencias', 'GET');
  return response;
}

// GUARDAR ACTIVOS FIJOS
export const GuardarHistorico = (Datos) => {
    const respuesta = PrivateInterceptor("Global/ActivoFijo/AgregarHistorico", "POST", {Datos});
    return respuesta;
};
